import { iDef } from 'core/util/TypeUtils';
import { pickBy } from 'lodash';
import queryString from 'query-string';
import { push, replace } from 'react-router-redux';

import { IMenuPage } from 'common/form/fields/PageField';
import ActionTypes from "core/actions/actionTypes";
import { IBreadcrumb } from 'core/util/IBreadcrumb';
import UrlUtil from 'core/util/UrlUtil';
import { string } from "prop-types";
import { ServerStyleSheet } from 'styled-components';
import IConfigService from 'core/service/config/IConfigService';
import ServiceRegistry from 'core/util/ServiceRegistry';
import { beginAjaxCall } from './ajaxStatusActions';
import { loadConfig, saveConfigSuccess } from './configActions';

export const pushPageParam = (key: string, value: string) => {
	return (dispatch, getState) => {

		// get the currnet query / search string form the store
		const search = getState().router.location.search;

		// parse it into an object
		const query = queryString.parse(search);

		// add the new key and value
		const newQuery = {...query, [key]: value};

		// dispatch to update search string in store
		dispatch(push({
			search: queryString.stringify(newQuery)
		}));
	};
};

export const pushPageParams = (...params: Array<{key: string, value: any}>) => {
	return (dispatch, getState) => {

		// get the currnet query / search string form the store
		const search = getState().router.location.search;

		// parse it into an object
		const query = queryString.parse(search);

		// add the new key and value
		const newQuery = {...query};

		for (const param of (params || [])) {
			newQuery[param.key] = param.value;
		}

		// dispatch to update search string in store
		dispatch(push({
			search: queryString.stringify(newQuery)
		}));
	};
};

export const saveAdminConfig = () => {
	return (dispatch, getState) => {
		dispatch(beginAjaxCall());

		const config = getState().config;
		const configService = ServiceRegistry.get(IConfigService);

		return configService.saveConfig(config, config.key).then(() => {
			dispatch(saveConfigSuccess(config.key));
		}).catch((error) => {
			throw (error);
		});
	};
};

export const replacePageParams = (...params: Array<{key: string, value: any}>) => {
	return (dispatch, getState) => {

		// get the currnet query / search string form the store
		const search = getState().router.location.search;

		// parse it into an object
		const query = queryString.parse(search);

		// add the new key and value
		const newQuery = {...query};

		for (const param of (params || [])) {
			newQuery[param.key] = param.value;
		}

		// dispatch to update search string in store
		dispatch(replace({
			search: queryString.stringify(newQuery)
		}));
	};
};

export const resetProgramPageParams = (paramToDelete) => {
	return (dispatch, getState) => {
		const search = getState().router.location.search;
		// parse it into an object
		const query = queryString.parse(search);
		// delete search query param 
		delete query[paramToDelete];
		const newQuery = {...query};

		dispatch(push({
			search: queryString.stringify(newQuery)
		}));
	};
};

export const setTrackPagination = (trackId: string, pageNumber: any) => {
	const trackPaginationVal = [{'trackId': trackId, 'pageNumber': pageNumber}]
	return { type: ActionTypes.SET_TRACK_PAGINATION, trackPaginationVal }; 
}


export const addItemsToCart=(payload)=> {
    return {
      type: ActionTypes.ADD_ITEMS_TO_CART,
      payload: payload
    }
  }

  export const removeItemsFromCart=(payload)=> {
    return {
      type: ActionTypes.REMOVE_ITEMS_FROM_CART,
      payload: payload
    }
  }

  export const removeQuantityFromCart=(payload)=> {
    return {
      type: ActionTypes.REMOVE_QUANTITY_FROM_CART,
      payload: payload
    }
  }

export const setQuantityInCart=(payload)=> {
	return {
		type: ActionTypes.SET_QUANTITY_IN_CART,
		payload: payload
	}
}

export const saveCartUserDetails=(payload) => {
	return {
		type: ActionTypes.SAVE_CART_USER_DETAILS,
		payload: payload
	}
}

export const resetCart = () => {
	return {
		type: ActionTypes.RESET_CART,
		payload: null,
	};
};

export const saveShippableUserDetails = (payload) => {
	return {
		type: ActionTypes.SAVE_SHIPPABLE_USER_DETAILS,
		payload: payload,
	};
};

export const saveForumId = (payload) => {
	return {
		type: ActionTypes.SAVE_FORUM_ID,
		payload: payload,
	};
};

export const saveUserPermission = (payload) => {
	return {
		type: ActionTypes.SAVE_USER_PERMISSION,
		payload: payload,
	};
};

export const setDiscountResponse=(payload)=> {
	return {
		type: ActionTypes.SET_DISCOUNT_RESPONSE,
		payload: payload
	}
}

export const setCartItemsGroupBuy=(payload)=> {
	return {
		type: ActionTypes.SET_CART_ITEMS_GROUP_BUY,
		payload: payload
	}
}

export interface IPageParam {
	key: string;
	value: string;
}

export const removePageParam = (key: string) => {
	return (dispatch, getState) => {
		const search = queryString.parse((getState().router.location.search));

		// dispatch to update search string in store
		dispatch(push({
			search: queryString.stringify(pickBy(search, (v, k: string) => k !== key))
		}));
	};
};

export const removePageParams = (keys: string[]) => {
	return (dispatch, getState) => {
		const search = queryString.parse((getState().router.location.search));

		// dispatch to update search string in store
		dispatch(push({
			search: queryString.stringify(pickBy(search, (v, k: string) => !keys.includes(k)))
		}));
	};
};

export const pushPagePath = (path: IMenuPage, params) => {
	return (dispatch, getState) => {

		// get the current query / search string form the store
		const search = getState().router.location.search;

		const page = getState().config.panels[path.instance];

		// prefix the path
		const p = UrlUtil.getLink(path.path, page.path);

		// parse it into an object
		const query = queryString.parse(search);

		// add the new key and value
		const newQuery = {...query, ...params};

		// dispatch to update search string in store
		dispatch(push({
			pathname: p,
			search: queryString.stringify(newQuery)
		}));
	};
};

export const pushPanelPath = (path: string[], params: boolean | object = {}, breadcrumbs?: IBreadcrumb[]) => {
	return (dispatch, getState) => {

		const state: any = getState();

		const pathname = UrlUtil.getPagePathLink(state , path);

		const search = typeof params === 'object' ?
			queryString.stringify({...queryString.parse(state.router.location.search), ...params})
			: (params ? state.router.location.search : '');

		dispatch(push({
			pathname,
			search
		}));

		dispatch(updateBreadcrumbs(breadcrumbs));
	};
};

export const updateParams = (instance: string, params: object) => {
	return { type: ActionTypes.QUERY_PARAMS_UPDATE, instance, params};
};

export const replaceParams = (instance: string, params: object) => {
	return { type: ActionTypes.QUERY_PARAMS_REPLACE, instance, params};
};

export const forceQueryRefresh = () => {
	return { type: ActionTypes.QUERY_FORCE_REFRESH };
};

export const updateBreadcrumbs = (breadcrumbs: IBreadcrumb[]) => {
	return { type: ActionTypes.BREADCRUMBS_UPDATE, breadcrumbs };
};

export const clearBreadcrumbs = () => {
	return { type: ActionTypes.BREADCRUMBS_UPDATE, breadcrumbs: [] };
};



// WEBPACK FOOTER //
// ./src/core/actions/paramsActions.ts